import * as types from '../../actions/actiontypes';
import initialstate from '../initialstate';
import {normalize, truthyWinsMergeStrategy} from '../../util/utils';
import {HttpStatusCodes, reducerOperations} from '../../util/uiconstants';
import Utility from '../../util/utilityfunctions';
import {labels} from '../../util/utils';

const filterStatefunc = (trialBalance, includeArray) => {
	let types = trialBalance.financialStatementsTypes;
	let financialStatementIds = trialBalance.financialStatement;
	let filteredIds = [];

	for (let i = 0; i < financialStatementIds.length; i++) {
		let financialStatementId = financialStatementIds[i];
		let type = types.find((t) => t.id === financialStatementId)?.financialStatementTypeId;

		if (!includeArray?.includes(type)) {
			filteredIds.push(financialStatementId);
		}
	}

	return {
		...trialBalance,
		financialStatements: filteredIds
	};
};

const filterTrialBalancesState = (trialBalances, includeArray) => {
	for (let i = 0; i < trialBalances.allIds.length; i++) {
		let trialBalanceId = trialBalances.allIds[i];

		trialBalances = {
			...trialBalances,
			byId: {
				...trialBalances.byId,
				[trialBalanceId]: filterStatefunc(trialBalances.byId[trialBalanceId], includeArray)
			}
		};
	}

	return trialBalances;
};

export function trialBalanceReducer(state = initialstate.trialBalances, action) {
	switch (action.type) {
		case types.CLEAR_TRIAL_BALANCE_DATA:
			return initialstate.trialBalances;
		case types.GET_TRIAL_BALANCE:
			if (action.response && action.responseObj.status === HttpStatusCodes.Ok) {
				let trialBalances = [];

				action.response.map((tb) => {
					const updatedFirstLevelFinancialStatements = tb.firstLevelFinancialStatements.map((financial) => {
						const matchingType = labels.financialStatementTypeIds.find(
							(type) => type.id === financial.financialStatementTypeId
						);
						if (matchingType) {
							return {
								...financial,
								financialStatementName: matchingType.label
							};
						}
						return financial;
					});
					let financialStatements = updatedFirstLevelFinancialStatements
						?.concat(tb.secondLevelFinancialStatements)
						?.concat(tb.thirdLevelFinancialStatements)
						?.concat(tb.fourthLevelFinancialStatements?.data);

					trialBalances.push({
						...tb,
						id: tb.id,
						trialBalanceTypeId: tb.trialBalanceTypeId,
						isCurrentVersion: tb.isCurrentVersion,
						currentPeriodDate: tb.currentperioddate,
						comparativePeriodDate: tb.comparativeperioddate,
						otherComparativePeriodDate: tb.othercomparativeperioddate,
						financialStatement: financialStatements?.map((fs) => fs.id),
						financialStatementsTypes: financialStatements?.map((fs) => {
							return {id: fs.id, financialStatementTypeId: fs.financialStatementTypeId};
						}),
						clientData: tb.fifthLevelFinancialStatements.data.map((item) => ({
							...item,
							displayOrder: (item.displayOrder = null)
						}))
					});
				});

				const filterState = filterTrialBalancesState(state, action.includeArray);

				return {
					...normalize(trialBalances, undefined, filterState, truthyWinsMergeStrategy)
				};
			}
			return state;
		case types.GET_TRIAL_BALANCE_BY_ID:
			if (action.response && action.responseObj.status === HttpStatusCodes.Ok) {
				const trialBalances = mapTrialBalance(action);
				const filterState = filterTrialBalancesState(state, action.includeArray);

				return {
					...normalize(trialBalances, undefined, filterState, truthyWinsMergeStrategy)
				};
			}
			return state;
		case types.GET_ADJUSTED_TRIAL_BALANCE_BY_ID:
			if (action.response && action.responseObj.status === HttpStatusCodes.Ok) {
				const trialBalances = mapTrialBalance(action);
				const filterState = filterTrialBalancesState(state, action.includeArray);

				return {
					...state,
					adjusted: normalize(trialBalances, undefined, filterState, truthyWinsMergeStrategy)
				};
			}
			return state;

		case types.MODIFY_GLACCOUNT_DOCUMENT: {
			const {trialBalanceId, document, operation} = action.payload;
			const trialBalance = state.byId[trialBalanceId];

			if (!trialBalance) {
				return state; // Early return if trialBalance is not found
			}

			const {glAccountDocuments} = trialBalance;
			let updatedGLAccountDocuments;

			switch (operation) {
				case reducerOperations.Add:
					updatedGLAccountDocuments = [...glAccountDocuments, {...document, isCompleted: true}];
					break;
				case reducerOperations.Remove:
					updatedGLAccountDocuments = glAccountDocuments.filter((doc) => doc.id !== document.id);
					break;
				default:
					return state; // If operation is not recognized, return the current state
			}

			// Return the updated state
			return {
				...state,
				byId: {
					...state.byId,
					[trialBalanceId]: {
						...trialBalance,
						glAccountDocuments: updatedGLAccountDocuments
					}
				}
			};
		}
		case types.POST_TRIAL_BALANCE_DATA: {
			return action.response ? action.response : state;
		}
		case types.DELETE_TRIAL_BALANCE: {
			return action.response ? action.response : state;
		}
		case types.PATCH_TRIAL_BALANCE: {
			return action.response ? action.response : state;
		}
		case types.PUT_TRIAL_BALANCE: {
			return action.response ? action.response : state;
		}
		default:
			return state;
	}
}

const mapTrialBalance = (action) => {
	let trialBalances = [];

	action.response.map((tb) => {
		const updatedFirstLevelFinancialStatements = tb.firstLevelFinancialStatements.map((financial) => {
			const matchingType = labels.financialStatementTypeIds.find(
				(type) => type.id === financial.financialStatementTypeId
			);
			if (matchingType) {
				return {
					...financial,
					financialStatementName: matchingType.label
				};
			}
			return financial;
		});
		let financialStatements = updatedFirstLevelFinancialStatements
			?.concat(tb.secondLevelFinancialStatements)
			?.concat(tb.thirdLevelFinancialStatements)
			?.concat(tb.fourthLevelFinancialStatements?.data);

		const evidence = tb.glAccountDocuments.sort(Utility.sortByMultipleKey('documentId'));
		const glAccountTickMarks = tb.glAccountTickMarks.sort(Utility.sortByMultipleKey('engagementTagId'));
		tb.fifthLevelFinancialStatements.data.forEach((item1) => {
			item1.displayOrder = null;
			const matchingItem = evidence.filter((item2) => item2.glAccountId === item1.id);
			const matchingTickMarks = glAccountTickMarks.filter((item2) => item2.glAccountId === item1.id);
			if (matchingTickMarks.length > 0) {
				item1.engagementTagNames = matchingTickMarks
					.map((item) => item.engagementTagName)
					.sort((a, b) => a.localeCompare(b));
				item1.engagementTagId = matchingTickMarks.map((item) => item.engagementTagId).sort((a, b) => a - b);
			}
			if (matchingItem) {
				if (matchingItem.length > 1) {
					let sortedDocs = Utility.sortListData(matchingItem, 'documentName', 'asc');
					item1.documentName = sortedDocs.map((item) => item.documentName.split(' ')[0]).join(', ');
				} else if (matchingItem.length === 1) {
					item1.documentName = matchingItem[0].documentName.split(' ')[0];
				}
			}
		});
		const glAccountDocuments = tb.glAccountDocuments.map((doc) => ({...doc, isCompleted: doc?.isCompleted ?? false}));
		trialBalances.push({
			...tb,
			id: tb.id,
			trialBalanceTypeId: tb.trialBalanceTypeId,
			isCurrentVersion: tb.isCurrentVersion,
			currentPeriodDate: tb.currentperioddate,
			comparativePeriodDate: tb.comparativeperioddate,
			otherComparativePeriodDate: tb.othercomparativeperioddate,
			financialStatement: financialStatements?.map((fs) => fs.id),
			financialStatementsTypes: financialStatements?.map((fs) => {
				return {id: fs.id, financialStatementTypeId: fs.financialStatementTypeId};
			}),
			evidence: tb.fifthLevelFinancialStatements?.data?.map((fs) => {
				return tb.glAccountDocuments.filter((gl) => gl.glAccountId === fs.id).map((gl) => gl.documentName);
			}),
			clientData: tb.fifthLevelFinancialStatements.data,
			glAccountDocuments: glAccountDocuments
		});
	});

	return trialBalances;
};
